import createIconComponent from './utils/createIconComponent';
import React from 'react';
const SearchMagnify = createIconComponent({
  height: 22,
  width: 22,
  content: (
    <>
      <circle cx='9.5' cy='9.5' r='7.5' stroke='#fff' stroke-width='2' />
      <rect
        width='1'
        height='7.942'
        x='14.389'
        y='15.096'
        fill='#003E6B'
        stroke='#fff'
        rx='.5'
        transform='rotate(-45 14.389 15.096)'
      />
    </>
  ),
});
SearchMagnify.displayName = 'SearchMagnify';
export default SearchMagnify;
